import React from 'react';

export function Card({ children, style = {}, onClick, className = "" }) {
  return (
    <div 
      onClick={onClick} 
      className={`eyvo-card ${onClick ? 'clickable' : ''} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}

export function StatCard({ label, value, sub, color }) {
  return (
    <Card>
      <div className="stat-label">{label}</div>
      <div className="stat-value" style={{ color: color || "var(--text)" }}>{value}</div>
      {sub && <div className="stat-sub">{sub}</div>}
    </Card>
  );
}

export default Card;
